<!--  -->
<template>
  <div class="content">
    <div class="ban">
     <img src="http://www.hitaledu.com/img/new.png" alt="湖南生易圈教育咨询有限公司" />
    </div>
    <!--列表 -->
    <div class="new_list">
      <Link text="了解更多资讯" />
      <div
        class="li card flex"
        v-for="(item, index) in list"
        :key="index"
        @click="see_info(item)"
      >
        <div class="left_img">
          <img :src="item.src1" alt="湖南生易圈教育咨询有限公司" />
        </div>
        <div class="center_text flex">
          <div class="text_left">
            <div class="title color">{{item.titel}}</div>
            <div class="text">
              <p>
                {{item.describe}}
              </p>
            </div>
          </div>
          <div class="text_row"></div>
          <div class="text_right flex">
            <div class="data_year">
              <div class="data color">{{item.day}}</div>
              <div class="year">{{item.year}}</div>
            </div>
            <span class="iconfont icon-angle-right ioc color"></span>
          </div>
        </div>
        <div class="right_row"></div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="count"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Link from "../../components/all_text.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
  },
  data() {
    //这里存放数据
    return {
      count:10,
      page:1,
      list:[],
     
      loading:'',
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    see_info(item) {
      this.$router.push({
        path: "/New_info",
        query: {
          id: item.id,
        },
      });
    },
    // 页码
    handleCurrentChange(val) {
      this.page=val;
      this.getData();
    },
    // 加载
      openFullScreen2() {
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
       
      },
    // 获取数据
    getData() {
      this.$http
        .get("http://www.hitaledu.com/admin/news/newsListJson?limit=10&page="+this.page)
        .then((response) => {
          if (response.data.code == 0) {
            console.log(response.data)
            this.list=response.data.data;
            this.count=response.data.count;
            this.loading.close();
          } else {
            this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this. openFullScreen2();
    this.getData();
   
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
@import url(../new/pc);
@import url(../new/mod);
// 分页
.page {
  padding: 20px 0;
  display: flex;
  justify-content: center;
}
</style>